import React from "react";

function FieldDisplay({ label, value, ...rest }) {
  return (
    <div {...rest}>
      {label}
      <strong className="float-end">{value}</strong>
    </div>
  );
}

export default FieldDisplay;
